import React from "react";
import { AvatarRing } from "../../../common/comms/AvatarRing";

/** Stable avatar colour per person — see ChatDockUserList for the rationale. */
const colorIndexFor = (id) => (id ? String(id).charCodeAt(0) % 8 : 0);

/**
 * Whose calendar this is, above a set of Bookings tabs.
 *
 * Used on both of the manager screen's states, which is the point of it being a
 * component: the manager's own (three calendars — their own bookings, their own
 * shifts, their team's — so it has to say whose "my" this is before the tabs mean
 * anything), and a coach opened out of My team, which replaces it. They read the
 * same way, so what's changed is only ever the name.
 *
 * It renders the page's h1 either way, which is sound precisely because the two
 * never appear together — the coach view takes the screen rather than nesting
 * inside the manager's.
 *
 * Purely presentational. The manager's subtitle is worked out by
 * `describeCoachRole`, which owns the role vocabulary; a coach's comes off their
 * roster row.
 *
 * @param {Object} props
 * @param {string} props.name - Display name; the avatar's initials come from it.
 * @param {string} [props.subtitle] - Role line, e.g. "Nutritionist manager".
 * @param {string} [props.colorSeed] - Stable id the avatar colour is derived
 *   from, so the same person is always the same colour.
 */
export const BookingsIdentityHeader = ({ name, subtitle, colorSeed }) => (
  <div className="flex items-center gap-3">
    <AvatarRing name={name} colorIndex={colorIndexFor(colorSeed)} size="md" />
    <div className="min-w-0">
      <h1 className="truncate text-base font-semibold text-bc-text">{name}</h1>
      {subtitle ? <p className="truncate text-xs text-bc-soft">{subtitle}</p> : null}
    </div>
  </div>
);
